import { Member } from '../../../../../../../api/groups';
import useTableData, { TocNodeRowHeader } from '../../hooks/useTableData';
import NodeResultCell from './components/NodeResultCell';
import NodeRowHeader from './components/NodeRowHeader';

interface Props {
  members: Member[];
  node: TocNodeRowHeader;
  isCollapsed: boolean;
  toggleCollapsed: () => void;
  getResult: ReturnType<typeof useTableData>['getResultForTocNode'];
}

export default function MultiMemberTocNodeRow({ members, node, isCollapsed, toggleCollapsed, getResult }: Props) {
  return (
    <tr>
      <NodeRowHeader node={node} isCollapsed={isCollapsed} toggleCollapsed={toggleCollapsed} />
      {members.map(member => (
        <NodeResultCell key={member.id} {...getResult(member.id, node.id)} />
      ))}
    </tr>
  );
}
